
import { InputNumber, message } from 'ant-design-vue';
import {
  defineComponent, inject, ref, watch, computed,
} from 'vue';
import { CheckOutlined } from '@ant-design/icons-vue';
import { promiseConfirm } from '@/lib/message';
import analysisService from '@/services/analysis.services';
import useAnalysisHooks from '@/hooks/analysis.hooks';

export default defineComponent({
  components: {
    aInputNumber: InputNumber,
    CheckOutlined,
  },
  props: {
    /** 题目id */
    questionId: {
      type: String,
    },
    /** 题目类型 */
    questionType: {
      type: Number,
    },
    /** 模式 —— stuSee|teaSee|preview|submit */
    cardModel: {
      type: String,
    },
    /** 学生有没有作对 */
    stuTrue: {
      type: Boolean,
    },
    /** 总分数 */
    score: {
      type: Number,
    },
    /** 学生分数 */
    stuScore: {
      type: Number,
    },
    /** 参考答案 —— 纯文字 */
    referenceAnswer: {
      type: String,
    },
    /** 解析 */
    analysis: {
      type: String,
    },
    /** 问答题-评分次数 */
    blankNumber: {
      type: Number,
    },
  },
  emits: ['on-save'],
  setup(props, { emit }) {
    const { saveTeacherCorrectQuestion } = analysisService();
    const analysisHooks = useAnalysisHooks();
    const jobView = inject('jobView');
    const assignmentId = inject<string>('assignmentId') || '';
    let stuCode = '';
    if (props.cardModel === 'teaSee') {
      stuCode = inject<string>('stuCode') || '';
    }
    const numberValue = ref(props.stuScore);
    const saveBlankScore = () => {
      promiseConfirm('得分仅可修改一次，确定修改吗?', async () => {
        await saveTeacherCorrectQuestion(assignmentId, props.questionId!, numberValue.value || 0, stuCode);
        message.success('成绩修改成功!');
        emit('on-save');
      });
    };

    const isPublish = computed(() => analysisHooks.currentAssignmentPublish.get() === '1');

    watch(() => numberValue, () => {
      numberValue.value = Math.floor(numberValue.value || 0);
    }, { deep: true });

    return {
      jobView,
      numberValue,
      saveBlankScore,
      isPublish,
    };
  },
});
